"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePath = void 0;
var exceptions_1 = require("./exceptions");
exports.resolvePath = function (base, redirect) {
    var SEP = '/';
    var basePath = base.endsWith(SEP) ? base.substr(0, base.length - 1) : base;
    var redirectPath = redirect;
    if (redirectPath.startsWith(SEP)) {
        basePath = redirectPath;
        redirectPath = '';
    }
    var path = redirectPath.length > 0 ? basePath + SEP + redirectPath : basePath;
    var parts = path.split(SEP);
    var pathStack = new Array();
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        if (part === '..') {
            if (pathStack.length === 0) {
                throw new exceptions_1.RelativePathException('Cannot redirect beyond root');
            }
            pathStack.pop();
        }
        else if (part !== '.') {
            if (part.length > 0) {
                pathStack.push(part);
            }
        }
    }
    return SEP + pathStack.join(SEP);
};
//# sourceMappingURL=urlrelativepathresolver.js.map